import type { CityConfig } from "../city-template/types";

export const beavercreekConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Dept of Health Vital Records", href: "https://odh.ohio.gov/vital-records/", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Greene County Probate Court", href: "https://www.greenecountyohio.gov/", description: "Greene County Probate Court — marriage license issuance" },
    { label: "Divorce Records — Greene County Clerk of Courts", href: "https://www.greenecountyohio.gov/", description: "Greene County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio DOH for online vital record orders" },
  ],
  city: "Beavercreek",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "beavercreek",
  route: "/cities/beavercreek",
  title: "Emergency Passport Beavercreek, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Beavercreek, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Greene County and the Dayton suburbs. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Beavercreek, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport in Beavercreek? We help Greene County and Dayton suburb travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beavercreek%20Ohio%20suburban%20community%20aerial%20view%20with%20rolling%20green%20landscape%2C%20residential%20streets%20and%20Dayton%20Ohio%20skyline%20in%20the%20distance%2C%20warm%20afternoon%20sunlight%20with%20blue%20sky%20and%20white%20clouds%2C%20professional%20suburban%20Ohio%20landscape%20photography%20with%20vibrant%20natural%20colors&width=1800&height=700&seq=beavercreek-oh-hero-001&orientation=landscape",
  heroImageAlt: "Beavercreek Ohio suburban landscape with Dayton skyline in the distance",
  geoPosition: "39.7092;-84.0633",
  geoPlacename: "Beavercreek, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 300 miles from Beavercreek via I-70",
  },
  nearbyCitiesZips: [
    { name: "Beavercreek", zips: "45430, 45431, 45432, 45434, 45440" },
    { name: "Xenia", zips: "45385" },
    { name: "Fairborn", zips: "45324" },
    { name: "Bellbrook", zips: "45305" },
    { name: "Dayton", zips: "45401–45475" },
    { name: "Kettering", zips: "45409, 45419, 45420, 45429, 45439, 45459" },
    { name: "Centerville", zips: "45458, 45459" },
    { name: "Springfield", zips: "45501–45506" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Beavercreek departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Greene County Coverage", desc: "Serving Beavercreek, Xenia, Fairborn, and Dayton suburbs" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Dayton, OH", route: "/dayton" },
    { name: "Fast passport renewal in Kettering, OH", route: "/cities/kettering" },
    { name: "Emergency passport help in Columbus, OH", route: "/cities/columbus-oh" },
    { name: "Urgent passport services in Cincinnati, OH", route: "/cities/cincinnati" },
    { name: "Same-day passport help in Springfield, OH", route: "/cities/springfield-oh" },
    { name: "Passport courier services in Hamilton, OH", route: "/cities/hamilton-oh" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Beavercreek remotely via secure courier. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, achieving 24–48 hour turnaround for Greene County travelers.",
  fpcOfficeAddress: "312 Walnut St, Cincinnati, OH 45202",
  fpcOfficeDistance: "Serving all of Greene County and the Dayton metropolitan area",
  serviceAreaIntro: "From Beavercreek proper to Xenia, Fairborn, and Bellbrook, Fast Passport Center serves the entire Greene County and Dayton suburb region.",
  nearbyCitiesIntro: "We serve Beavercreek neighborhoods and the surrounding communities including Xenia, Fairborn, Bellbrook, Dayton, Kettering, Centerville, and Springfield.",
  howItWorksIntro: "Most Greene County travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Beavercreek travelers often face a long drive to the Chicago Regional Passport Agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Greene County and Dayton suburb travelers trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Beavercreek? Here are the most common ones we hear from Greene County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail",
        "Can't upgrade speed after submission",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Beavercreek international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
    { name: "New Passport", description: "First-time passport application assistance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports." },
    { name: "Child Passport", description: "Passport services for minors under 16." },
    { name: "Name Change", description: "Passport correction and name change service." },
  ],
  testimonials: [
    {
      name: "Kimberly R.",
      location: "Beavercreek, OH",
      rating: 5,
      text: "My passport was stolen 2 weeks before my Japan trip. Fast Passport Center handled the DS-64 form and had my replacement in 3 days. Lifesaver!",
      service: "Lost Passport",
    },
    {
      name: "Tom J.",
      location: "Xenia, OH",
      rating: 5,
      text: "Business trip to Canada on 3 days notice. They got me a passport in 2 business days. Never knew it was possible without driving to Chicago.",
      service: "Emergency Passport",
    },
    {
      name: "Sandra M.",
      location: "Fairborn, OH",
      rating: 5,
      text: "Renewed my passport for a family trip to Italy. Fast Passport Center had it ready in 4 days. They answered every question I had.",
      service: "Passport Renewal",
    },
    {
      name: "Greg P.",
      location: "Bellbrook, OH",
      rating: 5,
      text: "First-time passport for my son. Fast Passport Center found the nearest acceptance facility and walked us through every step. Got it in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "beavercreek-1",
      name: "Beavercreek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3195 Dayton Xenia Rd",
      city: "Beavercreek",
      state: "OH",
      zip: "45434",
      phone: "(937) 426-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Beavercreek",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main Beavercreek facility. Call ahead for passport appointments.",
      icon: "ri-mail-line",
    },
    {
      id: "beavercreek-2",
      name: "Xenia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 E Main St",
      city: "Xenia",
      state: "OH",
      zip: "45385",
      phone: "(937) 372-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Greene County county seat",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Xenia and eastern Greene County residents. Ample parking.",
      icon: "ri-mail-line",
    },
    {
      id: "beavercreek-3",
      name: "Fairborn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 W Xenia Dr",
      city: "Fairborn",
      state: "OH",
      zip: "45324",
      phone: "(937) 878-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wright-Patterson AFB area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Wright-Patterson AFB and Fairborn residents.",
      icon: "ri-mail-line",
    },
    {
      id: "beavercreek-4",
      name: "Wright-Patterson AFB — Passports & Visas",
      type: "Military Base Passport Acceptance",
      address: "2175 Bong St",
      city: "Wright-Patterson AFB",
      state: "OH",
      zip: "45433",
      phone: "(937) 904-5834",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM",
      distance: "Wright-Patterson AFB base",
      website: "https://www.wpafb.af.mil/",
      websiteLabel: "WPAFB Services",
      notes: "Military ID required. Serves active duty and dependents.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Passport photos must be exactly 2×2 inches with a white or off-white background. Many local photo shops use wrong specs.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Greene County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many applicants show up with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "For minors, both parents must appear or submit notarized consent. Don't miss this requirement.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop documents at any UPS location in Beavercreek." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Beavercreek address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Beavercreek before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Beavercreek for travelers with urgent international flights. Our registered couriers achieve 24–48 hour turnaround without the 5+ hour drive to Chicago." },
    { q: "How fast can I renew my passport in Beavercreek?", a: "We offer fast passport renewal in Beavercreek in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What is the closest passport agency to Beavercreek, OH?", a: "The nearest regional passport agency to Beavercreek is the Chicago Passport Agency, approximately 300 miles away. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround." },
    { q: "Do I need to drive to Chicago for an emergency passport?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities." },
    { q: "Can I expedite a child passport in Beavercreek?", a: "Yes. We expedite child passports in Beavercreek for minors under 16. Both parents must appear or submit notarized consent." },
    { q: "What should I do if I lost my passport before a trip?", a: "Contact Fast Passport Center immediately. We provide lost passport replacement services in Beavercreek with DS-64 form guidance. Our emergency courier service can get your replacement in 24–48 hours." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Beavercreek", address: "4415 Indian Ripple Rd, Beavercreek, OH 45440", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Beavercreek", address: "3020 N Fairfield Rd, Beavercreek, OH 45432", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Beavercreek", address: "3360 Pentagon Blvd, Beavercreek, OH 45431", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Beavercreek", address: "4394 Indian Ripple Rd, Beavercreek, OH 45440", hours: "Mon–Fri: 8AM–8PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Beavercreek BMV Deputy Registrar",
      address: "3195 Dayton Xenia Rd, Beavercreek, OH 45434",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Xenia BMV Deputy Registrar",
      address: "1395 W 2nd St, Xenia, OH 45385",
      hours: "Mon–Fri: 9AM–5PM",
      note: "Alternative for east Greene County residents. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "8 miles west of Beavercreek",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Nearest airport for Beavercreek. Domestic flights to major hubs.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: true,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "80 miles east of Beavercreek",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with more international routes. Accessible via I-70.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International Airport",
      distance: "60 miles south of Beavercreek",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major hub with international flights. Consider for long-haul trips.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: false,
    },
  ],
};